module.exports = __webpack_public_path__ + "images/accents/accent-sl3-dials-cfa31bdb9a8248e2b81d2d4b38fbd006.webp";